import React from 'react';
import {
  Box,
  Card,
  CardBody,
  CardHeader,
  Heading,
  useColorModeValue,
} from '@chakra-ui/react';
import { useAuth } from '../contexts/AuthContext';
import { getEffectivePlan, PLAN_PRICING } from '../utils/planConfig';
import UsageMetrics from './plan/UsageMetrics';

const UsageDashboard: React.FC = () => {
  const { organization } = useAuth();
  const effectivePlan = getEffectivePlan(organization?.plan || 'free', organization?.trialEndsAt);
  const cardBg = useColorModeValue('white', 'gray.800');

  return (
    <Card bg={cardBg} borderRadius="xl" shadow="sm">
      <CardHeader pb={2}>
        <Heading size="sm">Plan usage — {PLAN_PRICING[effectivePlan].label}</Heading>
      </CardHeader>
      <CardBody pt={0}>
        <Box>
          <UsageMetrics />
        </Box>
      </CardBody>
    </Card>
  );
};

export default UsageDashboard;
